import styled from "styled-components"
import SecondaryButton from "../../Ui/Buttons/SecondaryButton"

export const Container = styled.div`
  margin-top: 2rem;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 0.6rem;
  padding: 1rem 2rem;

`

export const OrderButton = styled(SecondaryButton)`
margin-top: 2rem;

`
